var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9991_1007)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#27272C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 62.375C54 63.824 52.824 65 51.375 65H49.625C47.2397 65 45.0802 64.0358 43.5 62.4835C41.9198 64.0358 39.7603 65 37.375 65H35.625C34.176 65 33 63.824 33 62.375C33 60.926 34.176 59.75 35.625 59.75H37.375C39.3053 59.75 40.875 58.1802 40.875 56.25V31.75C40.875 29.8197 39.3053 28.25 37.375 28.25H35.625C34.176 28.25 33 27.074 33 25.625C33 24.176 34.176 23 35.625 23H37.375C39.7603 23 41.9198 23.9642 43.5 25.5165C45.0802 23.9642 47.2397 23 49.625 23H51.375C52.824 23 54 24.176 54 25.625C54 27.074 52.824 28.25 51.375 28.25H49.625C47.6947 28.25 46.125 29.8197 46.125 31.75V56.25C46.125 58.1802 47.6947 59.75 49.625 59.75H51.375C52.824 59.75 54 60.926 54 62.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9991_1007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleIcon);
export default __webpack_public_path__ + "static/media/title-icon.a1f1ecceb37c1676b6f7ea444d2bbfa9.svg";
export { ForwardRef as ReactComponent };